import * as Yup from 'yup'

export const EditRouteSchema = Yup.object().shape({
	maxPeopleCapacity: Yup.number()
		.required('Debes agregar un máximo de personas')
		.positive('Debe ser un número positivo mayor a 1')
		.nullable(),
})